import script from "./BirthMoment.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthMoment.vue?vue&type=script&setup=true&lang=js"

import "./BirthMoment.vue?vue&type=style&index=0&id=4e881a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e881a28"]])

export default __exports__